import { useEffect } from 'react'
import useGotchiOwner from 'state/vvsgotchi/hooks/useGotchiOwner'
import { useGameManager } from 'state/vvsgotchi/hooks/useGameManager'
import { playBgm, stopBgm } from 'state/vvsgotchi/bgm'
import { useVvsGotchiAudioModeManager, useBgmPlayer } from 'state/vvsgotchi/hooks/useConfigManager'

/**
 * Plays VvsGotchi BGM if requirements are met
 * there should be only 1 instance
 */
const VvsGotchiBgmPlayer: React.FC = () => {
  const { ready } = useGotchiOwner()
  const { isGameStarted } = useGameManager()
  const { bgmPlay } = useVvsGotchiAudioModeManager()
  const { bgmTmpPause, currentBgmSrc } = useBgmPlayer()

  useEffect(() => {
    if (ready && isGameStarted && bgmPlay && !bgmTmpPause) {
      playBgm(currentBgmSrc)

      const onVisibilitychange = () => {
        if (!document.hidden) {
          playBgm(currentBgmSrc)
        } else {
          stopBgm()
        }
      }
      document.addEventListener('visibilitychange', onVisibilitychange)
      return () => {
        stopBgm()
        document.removeEventListener('visibilitychange', onVisibilitychange)
      }
    }
    stopBgm()

    return () => undefined
  }, [currentBgmSrc, ready, isGameStarted, bgmPlay, bgmTmpPause])

  return null
}

export default VvsGotchiBgmPlayer
